var render = function render(){var _vm=this,_c=_vm._self._c;return _c('requisicao-form',{attrs:{"operacao":"I","errosPai":_vm.erros,"rota-listagem":this.rotaListagem,"rotaDetalhar":this.rotaDetalhar},on:{"salvar":function($event){return _vm.salvar($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }